import type { ImportedSteamInventoryItem, InventoryItem } from './index';

type Eligibility = Pick<InventoryItem, 'tradable' | 'marketable' | 'tradableAfter' | 'tradeRestrictionReason' | 'inventoryVerified'>;

/** A quote for an item name is not evidence that this owned asset has a resale value. */
export function canValueInventory(item: Eligibility) {
  if (item.inventoryVerified === false) return false;
  if (item.tradable || item.marketable) return true;
  if (item.tradeRestrictionReason === 'steam_untradable') return false;
  return item.tradeRestrictionReason === 'steam_trade_cooldown'
    || Boolean(item.tradableAfter && Number.isFinite(Date.parse(item.tradableAfter)));
}

export function withoutUnavailableInventoryPrice(item: ImportedSteamInventoryItem): ImportedSteamInventoryItem {
  if (canValueInventory(item)) return item;
  const { priceCny: _price, pricePlatform: _platform, referencePrice: _reference, ...rest } = item;
  return rest;
}

/** Only comparable CNY quotes participate in estimates and price sorting. */
export function inventoryValueCny(item: InventoryItem): number | undefined {
  if (!canValueInventory(item)) return undefined;
  const amount = item.referencePrice
    ? item.referencePrice.currency === 'CNY' ? item.referencePrice.amount : undefined
    : item.priceCny;
  return amount !== undefined && Number.isFinite(amount) && amount > 0 ? amount : undefined;
}

export function compareInventoryPrice(a: InventoryItem, b: InventoryItem, descending: boolean) {
  const left = inventoryValueCny(a), right = inventoryValueCny(b);
  if (left === undefined) return right === undefined ? 0 : 1;
  if (right === undefined) return -1;
  return descending ? right - left : left - right;
}
